<template>
  <div class="modal fade" id="customerBpmModal" tabindex="-1" aria-labelledby="customerBpmModalLabel" @keydown.esc="clearForm">
    <div class="modal-dialog" :class="{'modal-lg': search.step >= 1}">
      <div class="modal-content" v-if="!loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="customerBpmModalLabel">{{ clientType === 1 ? 'Страхователь' : clientType === 2 ? 'Водитель' : 'Выгодоприобретатель' }}</h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <customer-bpm-search
            v-if="search.step === 0"
            :is-clear="clear"
            :client-added-list="clientAddedList"
            :after-set="afterSet"
            :client-type="clientType"
            :search-data="search.data"
            :process-id="search.processId"
            :module="module"
            :mode="mode"
            @search-client="searchClient"
          />
          <customer-bpm-data
            v-if="search.step >= 1"
            :data-client="info[0]"
            :search-data="search.data"
            :is-clear="clear"
            :is-edit="isEdit"
            :module="module"
            :mode="mode"
            @change-filter-step="changeFilterStep"
            @update-client-data="updateClientData"
            @close-client-data="closeClientData"
          />
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            data-bs-dismiss="modal"
            @click="clearForm"
          >Закрыть</button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerBpmSearch from '@/components/Form/Bpm/Customer/CustomerBpmSearch'
import CustomerBpmData from '@/components/Form/Bpm/Customer/CustomerBpmData'
import LoaderFull from '@/components/Main/LoaderFull'

export default {
  name: 'CustomerBpmModal',
  components: {
    CustomerBpmSearch,
    CustomerBpmData,
    LoaderFull,
  },
  props: {
    clientAddedList: {
      type: Array,
      default: () => [],
    },
    client: {
      type: Object,
      default: null,
    },
    module: {
      type: Function,
      required: true,
    },
    mode: {
      type: [Object, Function],
      required: true,
    },
  },
  data () {
    return {
      search: {
        data: null,
        step: 0,
        processId: null,
      },
      clientType: 0,
      filterStep: 0,
      isEdit: false,
      clear: false,
      info: { 0: {} },
      loader: false,
      afterSet: null,
      filterSettings: null,
    }
  },
  watch: {
    client: {
      deep: true,
      immediate: true,
      handler (val) {
        this.applyModalState(val)
      },
    },
  },
  methods: {
    applyModalState (val) {
      if (!val) {
        this.clearForm()
        return
      }

      if (val.clientType != null) {
        this.clientType = val.clientType
        this.filterSettings = this.module.Client.filterFieldsSettings(this.clientType, {
          mode: this.mode,
          clientType: this.clientType,
        })
      }

      if (!val.data) {
        if (Object.prototype.hasOwnProperty.call(val, 'step') && val.step === 0) {
          this.isEdit = false
          this.info = { 0: {} }
          this.search.step = 0
          this.search.data = null
          this.search.processId = val.processId ?? null
          return
        }
        this.clearForm()
        return
      }

      if (Object.prototype.hasOwnProperty.call(val, 'step') && val.step === 0) {
        this.isEdit = false
        this.info = { 0: {} }
        this.search.step = val.step
        this.search.data = val.data
      } else {
        this.search.data = null
        this.info = { 0: val.data }
        this.isEdit = true
        this.search.step = 3
        this.search.edited = { key: val.key }
      }

      this.search.processId = val.processId ?? null
    },
    closeClientData (val) {
      if (Object.prototype.hasOwnProperty.call(this.info[0], 'client')) {
        this.valid = val === 1
      } else {
        this.valid = false
        this.search.step = 0
      }
    },
    updateClientData () {
      this.$notifyError('Действие не доступно')
    },
    changeFilterStep (val) {
      this.filterStep = val
    },
    modalHidden () {
      const modal = window.bootstrap?.Modal.getInstance(document.getElementById('customerBpmModal'))
      modal?.hide()
    },
    clearForm () {
      this.search.data = null
      this.search.step = 0
      this.search.processId = null
      this.isEdit = false
      this.clear = true
      this.info = { 0: {} }
      if (this.clear) {
        this.$emit('clearClient', this.clear)
        setTimeout(() => { this.clear = false }, 50)
      }
    },
    searchClient (val) {
      this.modalHidden()
      this.$emit('search-client', val)
    },
  },
}
</script>

<style scoped>

</style>
